const configuration = require('./agentExperience.json');

/** Only owner-approved public destinations belong in this configuration, never credentials. */
function contactRoute(value) {
  if (value == null || value === '') return null;
  if (typeof value !== 'string' || /[\s<>]/.test(value) ||
    Array.from(value).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) {
    throw new Error('Use a public HTTPS URL or a single mailto address.');
  }
  const url = new URL(value);
  if (url.username || url.password || url.search || url.hash) throw new Error('Contact destinations cannot contain credentials, queries or fragments.');
  if (url.protocol === 'mailto:') {
    if (!/^[^@/?#:,]+@[^@/?#:,]+\.[^@/?#:,]+$/.test(url.pathname)) throw new Error('Use one public email address.');
  } else if (url.protocol !== 'https:' || !url.hostname.includes('.') || url.port) {
    throw new Error('Use a public HTTPS destination.');
  }
  const host = url.protocol === 'mailto:' ? url.pathname.split('@')[1] : url.hostname;
  if (/(^|\.)(example\.(com|org|net)|example|invalid|test|localhost)$/.test(host) ||
    /(^|[./_-])(placeholder|your[-_]?key)([./_-]|$)/i.test(value)) {
    throw new Error('Replace placeholders or credential-bearing destinations with an approved public route.');
  }
  return url.href;
}

function getAgentExperience(input = configuration) {
  const result = { ...input, configurationErrors: [] };
  for (const field of ['requestUrl', 'supportUrl']) {
    try { result[field] = contactRoute(input[field]); }
    catch { result[field] = null; result.configurationErrors.push(field + ' is invalid.'); }
  }
  result.sections = input.sections.map((section) => {
    const paragraphs = [...section.paragraphs];
    if (section.id === 'request-access' && result.requestUrl) {
      paragraphs[0] = 'Use Request agent access below to contact the Audio at Play operator. Pilot access is reviewed; there is no self-service key issuance or automatic approval.';
      paragraphs[2] = 'The Audio at Play operator reviews applications and supplies dedicated integration credentials through a separately approved secure channel. Do not send credentials through the public request route.';
    }
    if (section.id === 'support' && result.supportUrl) {
      paragraphs[0] = 'Use Contact support below for pilot integration and delivery help. No response-time promise is made.';
    }
    return { ...section, paragraphs };
  });
  return result;
}

function contactReleaseIssues(input = configuration) {
  const data = getAgentExperience(input);
  return [...data.configurationErrors, ...['requestUrl', 'supportUrl'].filter((field) => !data[field])
    .map((field) => field + ' requires an owner-approved public destination.')];
}
module.exports = { contactRoute, getAgentExperience, contactReleaseIssues };
